import React from 'react';
import { FunctionComponentReturnType } from 'src/types/sharedReact';
import 'src/components/DevExFooter/DevExFooter.css';
import 'src/scripts/oneTag.js';

declare const window: any;

const footerSections = [
    {
        title: 'Resources',
        links: [
            { href: 'https://www.capitalone.com/privacy/', text: 'Privacy' },
        ],
    },
    {
        title: 'Support',
        links: [
            { href: '/dashboard/user-settings', text: 'Account Settings' },
        ],
    },
];

function DevExFooter(): FunctionComponentReturnType {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="devex-footer" id="custom-footer">
            <div className="devex-footer-content">
                <div className="devex-footer-brand">
                    <img
                        src="https://developer.capitalone.com/assets/svg/dx_mark_white.svg"
                        alt="Capital One DX Logo"
                        className="devex-footer-logo"
                    />
                    <span className="devex-footer-copyright">
                        &copy; {currentYear} Capital One
                    </span>
                </div>
                <div className="devex-footer-link-table">
                    {footerSections.map((section) => (
                        <div key={section.title}>
                            <h3>{section.title}</h3>
                            <ul>
                                {section.links.map((link) => (
                                    <li key={link.href}>
                                        <a
                                            href={link.href}
                                            target="_blank"
                                            rel="noreferrer"
                                            onClick={() =>
                                                window.oneTag?.track('link', {
                                                    event_name: 'link_click',
                                                    application_name: 'DevEx Analytics',
                                                    link_click_target_url: link.href,
                                                })
                                            }
                                        >
                                            {link.text}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </footer>
    );
}

export default DevExFooter;
